export const state = {
  isSidebarOpened: getSavedState('layout.isSidebarOpened'),
}

export const mutations = {
  SIDEBAR_TOGGLE(state) {
    state.isSidebarOpened = !state.isSidebarOpened
    saveState('layout.isSidebarOpened', state.isSidebarOpened)
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
